// Import model
import { DataviewSectionResponse } from '../models/DataviewSectionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterSectionRequest } from '../models/FilterSectionRequest';
import { Section } from '../models/Section';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterSectionRequestSerializer } from './FilterSectionRequestSerializer';
import { SectionSerializer } from './SectionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewSectionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewSectionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewSectionResponse instance
   */
  static deserialize(json: string): DataviewSectionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewSectionResponse instance
   */
  static fromObject(obj: any): DataviewSectionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewSectionResponse');
    }


    const instance: DataviewSectionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        SectionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterSectionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewSectionResponse instances
   */
  static deserializeArray(json: string): DataviewSectionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewSectionResponse instance to a JSON string
   */
  static serialize(instance: DataviewSectionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewSectionResponse instance to a plain object
   */
  static toObject(instance: DataviewSectionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        SectionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterSectionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewSectionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewSectionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
